import { render, staticRenderFns } from "./MyFavMobile.vue?vue&type=template&id=a1a7b76a&scoped=true"
import script from "./MyFavMobile.vue?vue&type=script&lang=js"
export * from "./MyFavMobile.vue?vue&type=script&lang=js"
import style0 from "./MyFavMobile.vue?vue&type=style&index=0&id=a1a7b76a&prod&scoped=true&lang=scss"
import style1 from "./MyFavMobile.vue?vue&type=style&index=1&id=a1a7b76a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a7b76a",
  null
  
)

export default component.exports